import { styled } from "../../config/stiches.config";
import type * as Stiches from "@stitches/react";
import NextImage from "next/image";
import { useMemo, useState } from "react";

export type AvatarProps = Stiches.VariantProps<typeof AvatarContainer> & {
  showRing?: boolean;
  imageFileEntry?: any;
  initials?: string;
  calendarColor?: string;
  imageUrl: string;
};
/**
 * 
 *     --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
 */
const AvatarContainer = styled("div", {
  borderRadius: "$radii$full",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  overflow: "hidden",
  boxSizing: "border-box",
  backgroundColor: "$colors$teal600",
  position: "relative",
  padding: "10px 12px",
  variants: {
    size: {
      xl: {
        width: "4rem",
        height: "4rem",
      },
      large: {
        width: "3rem",
        height: "3rem",
      },
      base: {
        width: "2.5rem",
        height: "2.5rem",
      },
      medium: {
        width: "2rem",
        height: "2rem",
      },
      small: {
        width: "1.5rem",
        height: "1.5rem",
      },
    },
  },
});

const AvatarText = styled("p", {
  color: "white",
  fontFamily: "$inter",
  variants: {
    size: {
      xl: {
        fontSize: "$5",
        fontHeight: "$5",
      },
      large: {
        fontSize: "$3",
        fontHeight: "$3",
      },
      base: {
        fontSize: "$2",
        fontHeight: "$2",
      },
      medium: {
        fontSize: "$2",
        fontHeight: "$2",
      },
      small: {
        fontSize: "$1",
        fontHeight: "$1",
      },
    },
  },
});

const AvatarImage = styled(NextImage, {});

export function SkipperAvatar({
  size,
  calendarColor,
  initials,
  showRing = false,
  imageUrl,
}: AvatarProps) {
  const [isError, setIsError] = useState(false);

  const cssStyle = useMemo(() => {
    if (!!showRing) {
      return {
        backgroundColor: calendarColor ?? "$colors$teal600",
        boxShadow: `#FFFF 0px 0px 0px 1px, ${calendarColor} 0px 0px 0px 3px`,
      };
    }
    return {
      backgroundColor: calendarColor ?? "$colors$teal600",
    };
  }, [calendarColor, showRing]);

  return (
    <AvatarContainer size={size} css={cssStyle}>
      {isError ||
        (!imageUrl && <AvatarText size={size}>{initials}</AvatarText>)}
      {imageUrl && !isError && (
        <AvatarImage
          src={imageUrl}
          alt="avatar image"
          layout="fill"
          onError={() => {
            setIsError(true);
          }}
          css={isError ? {} : { backgroundColor: "White" }}
          sizes="25vw"
        />
      )}
    </AvatarContainer>
  );
}
